module.exports = __webpack_public_path__ + "static/media/complete.b087e397.png";